import { toggleSortView } from "components/Stacker/actions/SearchActions"
import Icon from "components/Stacker/components/Icon/Icon"
import { setFilterOpenStatus } from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import ClearFilter from "components/Stacker/components/ClearFilter/ClearFilter"
import SearchSort from "components/Stacker/components/SearchSort/SearchSort"
import Events from "components/Stacker/constants/events"
import PropTypes from "prop-types"
import React from "react"
import SearchFilter from "../../Common/SearchFilter/SearchFilter"
import "./BraceletFilter.scss"
import { useDispatch, useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

export default function BraceletFilter({ onHelpClick, searchParams }) {
  const isFilterOpen = useSelector((state) => state.stacker.isFilterOpen)
  const { LL } = useI18nContext()
  const filters = useSelector((state) => state.search?.data?.facets)
  const selectedFilterCategory = useSelector(
    (state) => state.search.selectedFilterCategory
  )
  const search = useSelector((state) => state.search)
  const dispatch = useDispatch()

  const onHeaderUpdate = () => {
    dispatch(setFilterOpenStatus(!isFilterOpen))
  }

  const handleToggleSortView = (e) => {
    e.preventDefault()
    const { isSortViewExpanded } = search

    if (e.type === Events.ON_MOUSE_ENTER) {
      dispatch(toggleSortView(true))
    } else if (e.type === Events.ON_MOUSE_LEAVE) {
      dispatch(toggleSortView(false))
    } else if (e.type === Events.ON_CLICK || e.type === Events.ON_TOUCH_END) {
      dispatch(toggleSortView())
      if (!isSortViewExpanded) {
        //TODO: Where is handleOutisdeClick defined ?
        //shadowDOM.addEventListener('click', handleOutsideClick, false);
      }
    }
  }

  if (!search) {
    return null
  }

  const isSortViewExpanded = search.isSortViewExpanded
  const sorts = search.data.sorts
  const sort = search.queryParams.sort ?? "low_price asc"

  const filterHeaderClass = classNames(
    "product_list-bracelets-filter-header",
    "pb-5",
    {
      expanded: isFilterOpen,
    }
  )

  return (
    <div className="product_list-bracelets-filter">
      <div className={filterHeaderClass}>
        <div className="product_list-bracelets-filter-header-menu d-flex align-items-center">
          <div className="d-flex justify-content-between w-100">
            <span style={{ margin: "13px 0 0 0" }}>
              <button
                className="btn btn-text btn-text-icon text-uppercase"
                onClick={onHeaderUpdate}
              >
                <Icon
                  additionalClassNames="filter-icon-hamburger"
                  iconName="icon-hamburger-mobile"
                />
                <span>{LL.search.filterText()}</span>
              </button>

              {!isFilterOpen && searchParams.fq && (
                <React.Fragment>
                  <span className="clear-filter-container">
                    <span>|</span>
                    <ClearFilter />
                  </span>
                </React.Fragment>
              )}
            </span>
            <div style={{ height: 58 }}>
              <SearchSort
                searchSort={sorts}
                selectedSort={sort}
                handleToggleSortView={handleToggleSortView}
                isSortViewExpanded={isSortViewExpanded}
              />
              <button
                className="btn btn-icon icon icon-help d-lg-none d-none"
                onClick={onHelpClick}
              />
            </div>
          </div>
        </div>
        {filters && filters.length > 0 && (
          <div className="product_list-bracelets-filter-header-body">
            <SearchFilter
              filters={filters}
              //handleClearAllFilters={handleClearAllFilters}
              selectedFilterCategory={selectedFilterCategory}
              shouldShowOverlay={false}
            />
          </div>
        )}
      </div>
    </div>
  )
}

BraceletFilter.propTypes = {
  searchParams: PropTypes.object.isRequired,
  onHelpClick: PropTypes.func.isRequired,
}
